import { LayerItem } from 'src/types/layer'
import EditableCell, { ParseResult } from './EditableCell'

interface EditableOrderCellProps {
  rowData: LayerItem
  onUpdate: (id: string, orderNumber: number | null) => Promise<void>
}

const MAX_INT4 = 2_147_483_647
const MIN_INT4 = -2_147_483_648

const parseOrder = (raw: string): ParseResult<number | null> => {
  const trimmed = raw.trim()
  if (trimmed === '') return { value: null, valid: true }
  const n = Number(trimmed)
  if (!Number.isInteger(n)) return { valid: false, error: 'Order must be a whole number' }
  if (n < MIN_INT4 || n > MAX_INT4) return { valid: false, error: 'Order is out of range' }
  return { value: n, valid: true }
}

const EditableOrderCell = ({ rowData, onUpdate }: EditableOrderCellProps) => (
  <EditableCell
    value={rowData.orderNumber}
    minWidth="min-w-[60px]"
    inputType="number"
    inputClassName="w-16 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
    displayValue={(v) => v ?? '—'}
    parseValue={parseOrder}
    onSave={(order) => onUpdate(rowData.id, order)}
  />
)

export default EditableOrderCell
